import { createContext, useState, useContext } from 'react';

const SidebarContext = createContext<{expanded: boolean, setExpanded: (newState: boolean) => void} | undefined>(undefined);

function SidebarProvider({children}) {
  const [expanded, setExpanded] = useState(true);

  const value = { expanded, setExpanded }
  return (
    <SidebarContext.Provider value={value}>
      {children}
    </SidebarContext.Provider>
  )
}

function useSidebar() {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error('useSideBar must be used within a SideBarProvider')
  }
  return context
}

export { SidebarProvider, useSidebar, SidebarContext }
